/**
 * BAN の異議申し立て（components/AppealsPanel.tsx）の、画面に依らない決め事（2026-09-27 appeal-tools・Quality SEC-HIDE-03）。
 * サーバーは apps/server/src/modules/integrity（GET …/appeals・POST …/appeals/:appealId/resolve）。
 *
 * このファイルは import を持たない（featureToggle.ts と同じ理由: `node --test` で型の除去だけで動かす）。
 */

/** サーバーの返事の本文の上限（integrity/routes.ts の z.string().max(2000)）。超えると 400 になるので画面でも止める */
export const APPEAL_RESPONSE_MAX = 2000;

/**
 * 回答の本文。返事は前後の空白を落とし、空なら null（「返事なし」= プレイヤーの画面に空の返事を出さない）。
 * WHY null を送るか: サーバーは response を本人の制裁の一覧（GET /v1/players/me/sanctions の appeal.response）にそのまま返す。
 *   空文字を送ると「返事がある（中身が空）」になり、ゲームが空の吹き出しを出しかねない
 */
export function resolveBody(accept: boolean, response: string): { accept: boolean; response: string | null } {
  const text = response.trim();
  return { accept, response: text ? text.slice(0, APPEAL_RESPONSE_MAX) : null };
}

/**
 * 制裁の種類 → 画面の文言のキー。BAN と一時停止だけを名前で出し、それ以外は「その他の制裁」にまとめる。
 * WHY: 制裁の種類には最初の公開で見せない機能の名前（ランキングからの除外・チャットの発言停止）が入る（Quality SEC-HIDE-04）。
 *   ダッシュボードで掛けられる制裁は BAN だけ（PlayerDrawer）なので、ふつうは 'ban' しか来ない
 */
export function sanctionKindKey(kind: string): 'appeals.kind.ban' | 'appeals.kind.suspension' | 'appeals.kind.other' {
  if (kind === 'ban') return 'appeals.kind.ban';
  if (kind === 'suspension') return 'appeals.kind.suspension';
  return 'appeals.kind.other';
}
